/* Copyright (c) 2020-present CloudIO Inc */

import {
  AnalyzeContext,
  AnalyzeIssue,
  AnalyzeResult,
} from 'layout/Sidebar/panels/TreeView/AnalyzeUtils';
import { itemWithDefaultValues } from 'registry/Components';
import { Item, RequiredItem } from '../../../../registry/Component.type';
import { isEmpty } from 'utils/isEmpty';

export async function analyzeLOVColumn({
  platform,
  appUid,
  pageId,
  itemId,
  mgr,
}: AnalyzeContext): Promise<AnalyzeResult> {
  const alerts: AnalyzeIssue[] = [];
  const autoFixes: (() => void)[] = [];
  const page = platform.getPage(appUid, pageId);
  if (!page) {
    return null;
  }
  const item = itemWithDefaultValues(page[itemId]) as RequiredItem<'LOVColumn'>;
  const { returnValueAttribute } = item.props;

  const lovGridItems = platform.getChildrenOfType(
    appUid,
    pageId,
    page,
    item,
    'LOVGrid',
  );
  if (!lovGridItems.length) {
    alerts.push({
      key: `incomplete-${itemId}`,
      showItemId: itemId,
      alert: `Incomplete ${mgr.name}. Must have a LOV Grid!`,
      itemId,
    });
    return [alerts, autoFixes];
  }
  const lovGrid = lovGridItems[0];
  const cols = platform.getChildrenItems(
    appUid,
    pageId,
    page,
    lovGrid,
    (child) => {
      const c = child as Item<'StringColumn' | 'NumberColumn'>;
      return (
        c.props.viewAttribute === returnValueAttribute &&
        c.props.visible !== false &&
        isEmpty(c.props.visibleCondition)
      );
    },
  );

  if (!cols.length) {
    alerts.push({
      key: `incomplete-${itemId}`,
      showItemId: lovGrid.itemId,
      alert: `Incomplete LOV Grid. Must have an always visible column with view attribute same as the return value attribute ${returnValueAttribute}!`,
      itemId,
    });
    return [alerts, autoFixes];
  }

  return [alerts, autoFixes];
}
